import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import { accountAccessShowLogin, modalClose } from 'actions/UiActions'
import { hasPassedWalledGarden } from 'selectors/accountSelectors'

function useEuropeOfferPageWalledGarden(offerType?: App.OfferType) {
  const dispatch = useAppDispatch()

  const countryCode = useAppSelector(state => state.geo.currentRegionCode)
  const hasPassesWalledGarden = useAppSelector(state => hasPassedWalledGarden(state, offerType))

  // This hard wall is a UK-only treatment. Do not use the broader Europe-region
  // grouping here, as it also includes DE and other European storefronts.
  const isUK = countryCode === 'GB'

  useEffect(() => {
    if (!isUK || hasPassesWalledGarden) return

    dispatch(accountAccessShowLogin('login', false))

    return () => {
      dispatch(modalClose())
    }
  }, [countryCode, dispatch, hasPassesWalledGarden, isUK])

  return isUK
}

export default useEuropeOfferPageWalledGarden
